import { type ProjectCode } from '@constants'
import { createWithUpdateButlerToken, refreshButlerToken } from '@hooks-api/fortune/refreshButlerToken'
import { getClient } from '../../../../../clients'

const withUpdateButlerToken = createWithUpdateButlerToken(getClient('fortune'), getClient('butler'))

export interface RefreshButlerTokenProps {
  projectCode: ProjectCode
  campaignCode: string
}

export const RefreshButlerToken = (props: RefreshButlerTokenProps) => {
  const { projectCode, campaignCode } = props
  refreshButlerToken({ projectCode, code: campaignCode }, { use: [withUpdateButlerToken] })
  return null
}
